import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const ContactPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-white mt-32">
            {/* 页面标题区域 */}
            <div className="bg-gradient-to-r from-blue-800 to-indigo-900 py-16 text-center">
                <motion.h1
                    className="text-4xl font-bold text-white mb-4"
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    {t('contact.title', '联系我们')}
                </motion.h1>
                <motion.p
                    className="text-xl text-blue-100 max-w-3xl mx-auto px-4"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                >
                    {t('contact.subtitle', '我们期待听到您的声音，随时为您提供帮助')}
                </motion.p>
            </div>

            {/* 主要内容区域 */}
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-10">
                    {/* 联系信息 */}
                    <motion.div
                        className="bg-white p-6 rounded-lg shadow-md mx-auto w-full"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b border-gray-200 pb-2">
                            {t('contact.info.title', '联系方式')}
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                            {/* Address */}
                            <div className="flex items-start">
                                <div className="flex-shrink-0 mt-1">
                                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                        {t('contact.info.address.title')}
                                    </h3>
                                    <p className="text-gray-700">
                                        {t('contact.info.address.line1')}
                                    </p>
                                    <p className="text-gray-700">
                                        {t('contact.info.address.line2')}
                                    </p>
                                    <p className="text-gray-700">
                                        {t('contact.info.address.line3')}
                                    </p>
                                </div>
                            </div>
                            {/* 电话（学校要求不展示）
                            <div className="flex items-start">
                                <div className="flex-shrink-0 mt-1">
                                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                    </svg>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                        {t('contact.info.phone.title', '电话')}
                                    </h3>
                                    <p className="text-gray-700">
                                        <a href="tel:+161****2000">（612）405-2758</a>
                                    </p>
                                </div>
                            </div> */}
                        </div>
                        {/* Email 单独一行 */}
                        <div className="mt-8">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 mt-1">
                                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                                        {t('contact.info.email.title', '电子邮箱')}
                                    </h3>
                                    <p className="text-gray-700">
                                        info@great-lakes-academy.org
                                    </p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* 地图区域 */}
                {/* <motion.div 
                    className="mt-16"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b border-gray-200 pb-2">
                        {t('contact.map.title', '我们的位置')}
                    </h2>
                    <div className="bg-gray-200 rounded-lg overflow-hidden h-96 shadow-md">
                        <div className="w-full h-full flex items-center justify-center">
                            <p className="text-gray-500">{t('contact.map.placeholder', '地图加载中...')}</p>
                        </div>
                    </div>
                </motion.div> */}
            </div>
        </div>
    );
};

export default ContactPage; 